import React from "react";
import { useTranslation } from "react-i18next";
import { useTelemetry } from "../../context/TelemetryContext";
import TelemetryCard from "../../components/widgets/TelemetryCard";
import ModeIndicator from "../../components/shared/ModeIndicator";
import DemoDataNotice from "../../components/shared/DemoDataNotice";
import LanguageToggle from "../../components/shared/LanguageToggle";
import SubPageNav from "../../components/shared/SubPageNav";

function Telemetry() {
const { t } = useTranslation();

const telemetry = useTelemetry();

return (

<div
style={{
padding: "20px",
color: "white"
}}
>

<div style={{position:"relative",textAlign:"center",marginBottom:"10px"}}>
<h1 style={{margin:0}}>{t("telemetry.title")}</h1>
<div style={{position:"absolute",top:0,right:0,display:"flex",alignItems:"flex-start",gap:"12px"}}><LanguageToggle /><ModeIndicator /></div>
</div>

<p
style={{
textAlign:"center",
color:"#94a3b8",
marginBottom:"25px"
}}
>
{t("telemetry.subtitle")}
</p>

<div
style={{
display: "grid",
gridTemplateColumns: "1fr 1fr 1fr",
gap: "20px"
}}
>

<TelemetryCard
title={t("commandCenter.sensorInputs.pm25")}
value={telemetry.pm25}
subtitle={t("telemetry.cards.pm25Subtitle")}
/>

<TelemetryCard
title={t("commandCenter.sensorInputs.voc")}
value={telemetry.voc}
subtitle={t("telemetry.cards.vocSubtitle")}
/>

<TelemetryCard
title={t("commandCenter.sensorInputs.exposureSignal")}
value={telemetry.fentanyl_ppb}
subtitle={t("telemetry.cards.exposureSubtitle")}
/>

</div>

<div
style={{
display:"grid",
gridTemplateColumns:"1fr 1fr",
gap:"20px",
marginTop:"20px"
}}
>


{/* Telemetry Status */}

<div
style={{
marginTop: "20px",
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("telemetry.status.title")}</h3>

<div
style={{
marginTop: "15px",
display: "flex",
flexDirection: "column",
gap: "10px"
}}
>

<p>{t("telemetry.status.sensorNetwork", { value: t("commandCenter.status.online") })}</p>

<p>{t("telemetry.status.dataRefreshRate", { value: t("telemetry.status.dataRefreshRateValue") })}</p>

<p>
{t("telemetry.status.aiRiskLevel")}
<span
style={{
marginLeft: "10px",
fontWeight: "bold",
color:
telemetry.overallRisk === "CRITICAL"
? "#ef4444"
: telemetry.overallRisk === "WARNING"
? "#f59e0b"
: "#22c55e"
}}
>
{t(`commandCenter.risk.${telemetry.overallRisk}`, telemetry.overallRisk)}
</span>
</p>

</div>

</div>

{/* Telemetry Agent Activity */}

<div
style={{
marginTop: "30px",
background: "#111827",
padding: "25px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3
style={{
marginBottom: "20px"
}}
>
{t("telemetry.agentActivity.title")}
</h3>

<div
style={{
display: "flex",
flexDirection: "column",
gap: "12px"
}}
>

<div
style={{
padding: "12px",
background: "#0f172a",
borderRadius: "10px"
}}
>
{t("telemetry.agentActivity.telemetryAgent", { risk: t(`commandCenter.risk.${telemetry.overallRisk}`, telemetry.overallRisk) })}
</div>

<div
style={{
padding: "12px",
background: "#0f172a",
borderRadius: "10px"
}}
>
{t("telemetry.agentActivity.sensorAgent")}
</div>

<div
style={{
padding: "12px",
background: "#0f172a",
borderRadius: "10px"
}}
>
{t("telemetry.agentActivity.analyticsAgentPm25", { value: telemetry.pm25 })}
</div>

<div
style={{
padding: "12px",
background: "#0f172a",
borderRadius: "10px"
}}
>
{t("telemetry.agentActivity.analyticsAgentExposure", { value: telemetry.fentanyl_ppb })}
</div>

<div
style={{
padding: "12px",
background: "#0f172a",
borderRadius: "10px"
}}
>
{t("telemetry.agentActivity.dataQualityAgent")}
</div>

</div>

</div>
</div>

<div
style={{
display:"grid",
gridTemplateColumns:"1fr 1fr 1fr",
gap:"20px",
marginTop:"20px"
}}
>

{/* ===================================================== */}
{/* SENSOR HEALTH MONITOR */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("telemetry.sensorHealth.title")}
</h3>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px"
}}
>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.sensorHealth.pmSensor")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.online")}</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.sensorHealth.vocSensor")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.online")}</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.sensorHealth.exposureSensor")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.online")}</p>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.sensorHealth.gateway")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.connected")}</p>
</div>

</div>

</div>

{/* ===================================================== */}
{/* ENVIRONMENTAL ANALYTICS */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("telemetry.environmentalAnalytics.title")}
</h3>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(3,1fr)",
gap:"15px"
}}
>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.environmentalAnalytics.airQuality")}</h4>
<h2 style={{color:"#38bdf8"}}>
{telemetry.pm25}
</h2>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.environmentalAnalytics.vocIndex")}</h4>
<h2 style={{color:"#f59e0b"}}>
{telemetry.voc}
</h2>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.environmentalAnalytics.exposureIndex")}</h4>
<h2 style={{color:"#ef4444"}}>
{telemetry.fentanyl_ppb}
</h2>
</div>

</div>

</div>


{/* ===================================================== */}
{/* TELEMETRY TREND ANALYSIS */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("telemetry.trendAnalysis.title")}
</h3>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(6,1fr)",
gap:"10px",
alignItems:"end",
height:"120px"
}}
>

{[
  { time:"5m", value:25 },
  { time:"10m", value:35 },
  { time:"15m", value:45 },
  { time:"20m", value:60 },
  { time:"25m", value:75 },
  { time:"30m", value:90 }
].map((item,index)=>(

<div
key={index}
style={{
display:"flex",
flexDirection:"column",
alignItems:"center",
justifyContent:"flex-end"
}}
>

<div
style={{
width:"24px",
height:`${item.value}px`,
background:
item.value > 80
? "#ef4444"
: item.value > 60
? "#f59e0b"
: "#22c55e",
borderRadius:"4px"
}}
/>

<div
style={{
marginTop:"8px",
fontSize:"12px"
}}
>
{item.value}
</div>

<div
style={{
fontSize:"11px",
color:"#94a3b8",
marginTop:"4px"
}}
>
{item.time}
</div>

</div>

))}

</div>

</div>

</div>


<div
style={{
display:"grid",
gridTemplateColumns:"1fr 1.5fr 2fr",
gap:"20px",
marginTop:"20px"
}}
>

{/* ===================================================== */}
{/* EXPOSURE SIGNAL TRACKER */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("telemetry.exposureTracker.title")}
</h3>

<div
style={{
width:"100%",
height:"18px",
background:"#0f172a",
borderRadius:"20px",
overflow:"hidden"
}}
>

<div
style={{
width:`${Math.min(100, telemetry.fentanyl_ppb * 10)}%`,
height:"100%",
background:
telemetry.fentanyl_ppb > 7
? "#ef4444"
: telemetry.fentanyl_ppb > 3
? "#f59e0b"
: "#22c55e"
}}
/>

</div>

<div
style={{
textAlign:"center",
marginTop:"12px"
}}
>

<h2
style={{
fontSize:"24px",
fontWeight:"bold",
marginBottom:"10px"
}}
>
{telemetry.fentanyl_ppb} ppb
</h2>

<p
style={{
color:"#94a3b8",
marginBottom:"15px"
}}
>
{t("telemetry.exposureTracker.monitoring")}
</p>

<p
style={{
color:"#cbd5e1",
marginBottom:"10px"
}}
>
{t("telemetry.exposureTracker.status")}
<span
style={{
marginLeft:"6px",
color:
telemetry.fentanyl_ppb > 7
? "#ef4444"
: telemetry.fentanyl_ppb > 3
? "#f59e0b"
: "#22c55e"
}}
>
{
telemetry.fentanyl_ppb > 7
? t("commandCenter.risk.CRITICAL")
: telemetry.fentanyl_ppb > 3
? t("commandCenter.risk.WARNING")
: t("commandCenter.risk.SAFE")
}
</span>
</p>

<p
style={{
color:"#94a3b8",
marginBottom:"8px"
}}
>
{t("telemetry.exposureTracker.trend")}{" "}
{
telemetry.fentanyl_ppb > 7
? t("telemetry.exposureTracker.trendRapidlyIncreasing")
: telemetry.fentanyl_ppb > 3
? t("telemetry.exposureTracker.trendIncreasing")
: t("telemetry.exposureTracker.trendStable")
}
</p>

<p
style={{
color:"#94a3b8"
}}
>
{t("telemetry.exposureTracker.lastAlert")}{" "}
{
telemetry.fentanyl_ppb > 3
? t("telemetry.exposureTracker.lastAlertValue")
: t("telemetry.exposureTracker.lastAlertNone")
}
</p>

<p
style={{
color:"#64748b",
fontSize:"0.75rem",
fontStyle:"italic",
marginTop:"8px"
}}
>
{t("telemetry.exposureTracker.signalScopeNote")}
</p>

</div>
</div>
{/* ===================================================== */}
{/* SENSOR NETWORK STATUS */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("telemetry.sensorNetworkStatus.title")}
</h3>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px"
}}
>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.sensorNetworkStatus.activeSensors")}</h4>
<h2 style={{color:"#22c55e"}}>24</h2>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.sensorNetworkStatus.gateways")}</h4>
<h2 style={{color:"#38bdf8"}}>8</h2>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.sensorNetworkStatus.dataPackets")}</h4>
<h2 style={{color:"#f59e0b"}}>9,634</h2>
<DemoDataNotice textKey="common.demoDataNotice.simulatedCount" />
</div>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.sensorNetworkStatus.uptime")}</h4>
<h2 style={{color:"#22c55e"}}>99.8%</h2>
</div>

</div>

</div>

{/* ===================================================== */}
{/* TELEMETRY AGENT NETWORK */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("telemetry.agentNetwork.title")}
</h3>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px",
textAlign:"center"
}}
>

<div>
<h4>{t("telemetry.agentNetwork.telemetryAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

<div>
<h4>{t("telemetry.agentNetwork.sensorAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

<div>
<h4>{t("telemetry.agentNetwork.analyticsAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

<div>
<h4>{t("telemetry.agentNetwork.dataQualityAgent")}</h4>
<p style={{color:"#22c55e"}}>{t("commandCenter.status.active")}</p>
</div>

</div>

</div>
</div>

<div
style={{
display:"grid",
gridTemplateColumns:"1fr 1fr",
gap:"20px",
marginTop:"20px"
}}
>

{/* ===================================================== */}
{/* DATA QUALITY MONITOR */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("telemetry.dataQualityMonitor.title")}
</h3>

<div
style={{
display:"grid",
gridTemplateColumns:"repeat(4,1fr)",
gap:"15px"
}}
>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.dataQualityMonitor.completeness")}</h4>
<h2 style={{color:"#22c55e"}}>99%</h2>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.dataQualityMonitor.accuracy")}</h4>
<h2 style={{color:"#38bdf8"}}>97%</h2>
<DemoDataNotice textKey="common.demoDataNotice.illustrativeFigure" />
</div>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.dataQualityMonitor.latency")}</h4>
<h2 style={{color:"#f59e0b"}}>3 sec</h2>
</div>

<div style={{textAlign:"center"}}>
<h4>{t("telemetry.dataQualityMonitor.integrity")}</h4>
<h2 style={{color:"#22c55e"}}>{t("commandCenter.status.pass")}</h2>
</div>

</div>

</div>

{/* ===================================================== */}
{/* TELEMETRY CONFIDENCE METER */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
textAlign:"center",
marginBottom:"20px"
}}
>
{t("telemetry.confidenceMeter.title")}
</h3>

<div
style={{
width:"100%",
height:"18px",
background:"#0f172a",
borderRadius:"20px",
overflow:"hidden"
}}
>

<div
style={{
width:`${telemetry.aiConfidence}%`,
height:"100%",
background:"#22c55e"
}}
/>

</div>

<div
style={{
textAlign:"center",
marginTop:"12px",
fontSize:"20px",
fontWeight:"bold"
}}
>
{telemetry.aiConfidence}%
</div>

</div>
</div>



{/* ===================================================== */}
{/* EXECUTIVE TELEMETRY SUMMARY */}
{/* ===================================================== */}

<div
style={{
marginTop:"20px",
background:"#111827",
padding:"25px",
borderRadius:"14px",
border:"1px solid #1e293b",
textAlign:"center"
}}
>

<h3>
{t("telemetry.summary.title")}
</h3>

<p
style={{
marginTop:"15px",
color:"#94a3b8",
lineHeight:"1.8"
}}
>
{t("telemetry.summary.text")}
</p>

</div>

<SubPageNav current="telemetry" />

</div>
);

}

export default Telemetry;